import { ICategory } from 'types';

export const replaceCategoryChildren = <T extends ICategory>(
  parentId: string,
  subcategories: T[],
  categoriesHierarchy: T[]
): ICategory[] => {
  return categoriesHierarchy.map((category) => {
    const { nodeId: { nodeId } = {}, children = [] } = category;

    if (parentId === nodeId) {
      return { ...category, children: subcategories, hasChildren: children.length > 0 };
    }

    if (children && children.length > 0) {
      return {
        ...category,
        children: replaceCategoryChildren(parentId, subcategories, children),
      };
    }

    return category;
  });
};
